import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';

import { ContentType, ContentTypeSchema } from '../commons';

export namespace AssetFieldDefinition {
  export const TYPE = 'assetReference';
}

/**
 * Field definition of type asset
 * @typedef AssetFieldDefinition
 * @property - type : type of the field.
 * @property - i18n : an optional translatable properties of the field.
 * @property - validations : an optional object for defining rules about how a module definition can be instantiated. (contentTypeRestrictions - allowed content types.)
 */
export type AssetFieldDefinition = BaseFieldDefinition & {
  type: typeof AssetFieldDefinition.TYPE;
  i18n?: boolean;
  validations?: {
    contentTypeRestrictions?: ReadonlyArray<ContentType>;
  };
};

export const AssetFieldDefinitionSchema: Schema<AssetFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(AssetFieldDefinition.TYPE),
      i18n: z.boolean().optional(),
      validations: z
        .object({
          contentTypeRestrictions: z.array(ContentTypeSchema).optional()
        })
        .optional()
    })
  );
